import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';

export const WidgetSpeechBubble: Widget = {
    type: 'speechBubble',
    id: 'speech-bubble',
    name: 'Speech Bubble',
    position: {
        grid: {
            enabled: true,
            columns: {
                start: 4,
                end: 8,
            },
            rows: {
                start: 2,
                end: 4,
            },
        },
    },
    label: {
        titleText: 'Speech Bubble',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        contentRichText: {
            entityMap: {},
            blocks: [
                {
                    key:
                        'key_' +
                        Math.random()
                            .toString(36)
                            .substr(2, 9),
                    text: 'Rich Text',
                    type: 'unstyled',
                    depth: 0,
                    inlineStyleRanges: [
                        {
                            offset: 0,
                            length: 9,
                            style: 'CUSTOM_FONT_SIZE_20' as any,
                        },
                    ],
                    entityRanges: [],
                    data: {},
                },
            ],
        },
    },
};
